import {
  useMutationReadNotifications,
  useQueryInfiniteAllNotificationAlert,
  useQueryNotificationAlertCountUnread,
} from '@/api/queries/notification';

import ChecksIcon from '@/assets/icons/checks.svg';
import ShipIcon from '@/assets/icons/ship.svg';
import NotificationItem from "@/featured/apps/components/notification/components/NotificationItem";
import { NotificationItemSkeleton } from "@/featured/apps/components/notification/components/NotificationItemSkeleton";
import { AlarmVoyager } from '@/types/api';
import clsx from 'clsx';
import { Fragment } from 'react';
import toast from 'react-hot-toast';

type Props = {};

export default function NotificationVoyager({}: Props) {
  const dataNotificationVoyager = useQueryInfiniteAllNotificationAlert('voyager', 'created_at', 'desc');
  const notificationAlertCountUnread = useQueryNotificationAlertCountUnread();
  const { isPending: isPendingReadNotification, mutateAsync: readNotification } =
    useMutationReadNotifications();

  if (dataNotificationVoyager.isLoading || isPendingReadNotification)
    return <NotificationItemSkeleton />;

  // @ts-ignore
  if ((dataNotificationVoyager?.data?.pages?.[0]?.data || []).length === 0)
    return (
      <h2 className="focus:outline-none text-sm leading-normal text-center pt-8 pb-2 border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 notification-center">
        Notification Empty
      </h2>
    );

  return (
    <div className="2xl:w-full h-auto overflow-y-auto py-2 px-4 absolute right-0">
      {(notificationAlertCountUnread?.data?.voyager_alarm ?? 0) !== 0 && (
        <button
          disabled={(notificationAlertCountUnread?.data?.voyager_alarm ?? 0) === 0}
          onClick={() => {
            readNotification('voyager');
            toast.success('All voyager notifications marked as read');
          }}
          className={clsx(
            'mb-2 flex items-center justify-center gap-2 float-right',
            'text-slate-500 hover:text-green-500 dark:text-slate-300 dark:hover:text-green-400',
            (notificationAlertCountUnread?.data?.voyager_alarm ?? 0) === 0 && 'cursor-not-allowed opacity-50'
          )}
        >
          Mark All as Read <ChecksIcon size={14} />
        </button>
      )}

      {!dataNotificationVoyager?.isLoading && (
        <>
          {dataNotificationVoyager?.data?.pages.map((group: any, i: any) => (
            <Fragment key={i}>
              {group.data.map((item: AlarmVoyager) => (
                <NotificationItem
                  key={item?.id}
                  message={item?.message}
                  Icon={<ShipIcon className="h-5 w-5" />}
                  isRead={
                    !!item.open_at || (notificationAlertCountUnread?.data?.voyager_alarm ?? 0) === 0
                  }
                />
              ))}
            </Fragment>
          ))}

          {dataNotificationVoyager?.isFetchingNextPage ? (
            <p className="text-slate-400 dark:text-slate-500 text-sm text-center">Loading...</p>
          ) : (
            dataNotificationVoyager.hasNextPage && (
              <div className="flex justify-center items-center">
                <button
                  className="focus:outline-none bg-gray-100 dark:bg-gray-700 text-slate-600 dark:text-slate-300 p-3 py-1 rounded-lg text-xs mt-4 hover:bg-gray-200 dark:hover:bg-gray-600"
                  onClick={() => dataNotificationVoyager.fetchNextPage()}
                >
                  Load More
                </button>
              </div>
            )
          )}
        </>
      )}
    </div>
  );
}
